<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h3 class="card-title">Remover tabela</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p class="mb-3">
                                    Tem certeza que deseja remover a tabela de
                                    dados <strong>{{ table.name }}</strong
                                    >?<br />
                                    <span class="text-red"
                                        >Todos os registros da tabela serão
                                        removidos e esta ação não poderá ser
                                        desfeita!</span
                                    >
                                </p>
                                <div class="form-group">
                                    <label class="form-label"
                                        >Para confirmar a remoção, digite abaixo
                                        o texto
                                        <span class="bg-red-lt px-1">{{
                                            table.name
                                        }}</span
                                        >:</label
                                    >
                                    <input
                                        id="confirmationInput"
                                        v-model="tableNameConfirmation"
                                        type="text"
                                        class="form-control"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col">
                                <a
                                    id="cancelAndBackButton"
                                    href="/database/tables/"
                                    class="btn"
                                >
                                    <i class="ti ti-arrow-left"></i>
                                    Cancelar e voltar
                                </a>
                            </div>
                            <div class="col-auto">
                                <a
                                    id="removeTableButton"
                                    class="btn btn-danger"
                                    @click="removeTable"
                                >
                                    <i class="ti ti-trash"></i>
                                    Remover tabela
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "../services/api"
import EventBus from "../services/event-bus"

export default {
    name: "DbTableDeletePage",
    data() {
        return {
            tableNameConfirmation: "",
            table: {}
        }
    },
    async mounted() {
        var id = this.$route.params.table_id
        var response = await Api.database.tables.get(id)
        this.table = response.data
    },
    methods: {
        async removeTable() {
            var id = this.$route.params.table_id

            try {
                if (this.validate()) {
                    await Api.database.tables.delete(id)

                    this.$router.push("/database/tables")

                    EventBus.emit("message", {
                        type: "success",
                        message: "A tabela foi removida com sucesso!"
                    })
                }
            } catch (error) {
                EventBus.emit("message", {
                    type: "error",
                    message: "Erro ao remover a tabela:" + error
                })
            }
        },
        validate() {
            if (this.table.name !== this.tableNameConfirmation) {
                EventBus.emit("message", {
                    type: "warning",
                    message: "O nome da tabela não confere com o nome digitado!"
                })

                return false
            }
            return true
        }
    }
}
</script>
